import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function InsertSigner(item) {
  return client.post("Signers/InsertSigner", prepareDataRequest(item));
}

function GetAllSigners() {
  const data = {};
  return client.post("Signers/GetAllSigners", prepareRequest(data));
}

function UpdateSigner(item) {
  return client.post("Signers/UpdateSigner", prepareDataRequest(item));
}

function UpdateSignerStatus(item) {
  return client.post("Signers/UpdateSignerStatus", prepareDataRequest(item));
}

function DeleteSigner(id, uid, signerUid, newSignerUid = null) {
  var item = { id: id, commandUserId: uid, uId: signerUid, newSignerUid: newSignerUid };
  return client.post("Signers/DeleteSigner", prepareDataRequest(item));
}

function CheckPendingApprovals(uid) {
  const data = { Id: uid };
  return client.post("Signers/CheckPendingApprovals", prepareRequest(data));
}

export {
  InsertSigner,
  GetAllSigners,
  UpdateSigner,
  UpdateSignerStatus,
  DeleteSigner,
  CheckPendingApprovals
}